import { notificationSystem } from '@/assets/notifications.json';

export default {
  data: () => ({
    notificationSystem,
  }),
  methods: {
    // eslint-disable-next-line no-unused-vars
    getQuestionObj(method, redirect = '', msg) {
      return {
        timeout: 15000,
        close: false,
        overlay: true,
        toastOnce: true,
        id: 'question',
        zindex: 999999,
        position: 'center',
        buttons: [
          ['<button><strong>Sim</strong></button>', async (instance, toast) => {
            method();

            if (redirect.length > 0) {
              this.$router.push({ name: redirect });
            }

            instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
          }, true],
          ['<button>Não</button>', (instance, toast) => {
            instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
          }],
        ],
      };
    },
  },
};
